const debug = require('debug')('xlite-web-client:socketioservice')
const { io } = require("socket.io-client");
import formatDevice from '@/utilities/UserAgentFormat.js'
import store from '../store'

const decodedCfg = window.slwCfg ?  JSON.parse(Buffer.from(window.slwCfg, 'base64').toString('utf8')) : undefined
const wsHost = decodedCfg ?  decodedCfg.slwApiHost : process.env.VUE_APP_SLW_API_HOST
const wsPort = decodedCfg ?  decodedCfg.slwApiPort : process.env.VUE_APP_SLW_API_PORT

class SocketIOService {
    socket;
    constructor() {
        //
    }
  
    setupSocketConnection() {

        this.socket = io(`https://${wsHost}:${wsPort}`,
            {
                withCredentials: true
            }
        )

        this.socket.on('connect', () => {
            debug('Socket', this.socket.id)
        })

        this.socket.on('st', async (arg) => {
            const ua = formatDevice(arg)
            debug(`Your session has been terminated from another device: ${ua}`);
            await store.dispatch('setStt', ua)
            store.dispatch('setA', false)
        });
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect()
        }
    }
    
}

export default new SocketIOService()